module.exports = __webpack_public_path__ + "img/switched-stamp.ad88b18.svg";